import { logger } from '@/utils/logger';
import appServices from '@/services/appServices';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    logger.debug('/_authenticated beforeLoad check');

    // Wait for auth service to initialize
    if (!appServices.auth.isInitialized) {
      logger.debug('Auth service not initialized yet, waiting...');
      return;
    }

    if (!appServices.auth.isAuthenticated()) {
      logger.debug('Not authenticated, redirecting to /auth/signin');
      throw redirect({
        to: '/auth/signin',
        search: {
          // Use the current location to power a redirect after login
          redirect: location.href,
        },
      });
    }

    logger.debug('Authenticated, allowing access to protected route');
  },
  component: () => <Outlet />,
});
